const NotificationsTypes = {
    ERROR: 'ERROR',
    SUCCESS: 'SUCCESS',
    WARNING: 'WARNING'
}

export default NotificationsTypes